var render = function render(){var _vm=this,_c=_vm._self._c;return _c('lottie-animation',{ref:"anim",staticClass:"svg_wrapper",staticStyle:{"width":"122px","height":"122px","transform":"translate3d(0px, 0px, 0px) scale(1.25)"},attrs:{"animationData":require('@/assets/anim/phone-dash.json'),"loop":true,"autoPlay":true,"speed":1}})
}
var staticRenderFns = []

export { render, staticRenderFns }